e360.controller('InviteeEmailController', [
   '$scope',
   '$uibModalInstance',
   'session',
   'inviteesApi',
   'campaignsApi',
   'experiencesConstants',
   'experiencesService',
   'editorCodeParser',
   'emailApi',
   'emailParams',
   '$templateCache',

   function ($scope, $uibModalInstance, session, inviteesApi,
      campaignsApi, experiencesConstants, experiencesService, editorCodeParser,
      emailApi, emailParams, $templateCache
   ) {
      $scope.invitees = {};
      $scope.loaded = {};
      $scope.noExperience = false;
      $scope.confirm = false;
      $scope.groupType = 1;
      $scope.deployName = null;
      $scope.templates = [];

      // email editor templates expect view model named $ctrl
      $scope.$ctrl = {};

      Object.defineProperty($scope.$ctrl, 'language', {
         get: function() {
            return $scope.language;
         }
      });

      var env = session.deploymentName() == 'prod' ? 'prod' : 'dev'; // Want to use raw API domain specific response for email templates, but there's no templates for staging yet
      var typeDef = experiencesService.getTypeBySlug('invite-email');
      var campaign = session.getCampaign();

      experiencesService.list(campaign.id).then(function(res) {
         var experience = _.find(res, function(exp) {
            return exp.type === experiencesConstants.TYPE_EMAIL
               && exp.settings.emailName == 'RsvpInvite';
         });

         // falsy model means no DIY or custom template, can't continue
         // ATM server will fail without RsvpInvite email configured, even when
         // super admin selects alternate template
         if (!experience) {
            $scope.noExperience = true;
            throw("No experience set up");
         // DIY email experiences have non-zero ID, custom email has zero ID
         } else if (experience.id) {
            $scope.$ctrl.settings = experience.settings;
            var template = typeDef.mandrill_template.replace('-env-', '-' + env + '-');
            $scope.loaded.experience = true;
            return emailApi.templateInfo(template);
         }

      }).then(function(templates) {
         return inviteesApi.list(emailParams);

      }).then(function(res) {
         // with idsOnly=true response is an array, not paged list object
         $scope.invitees.all = res;
         $scope.loaded.all = true;
         emailParams.noInviteEmail = true;

         return inviteesApi.list(emailParams);

      }).then(function(res) {
         // with idsOnly=true response is an array, not paged list object
         $scope.invitees.noEmail = res;

         return campaignsApi.get(campaign.id);

      }).then(function (result) {
         var campaign = result;
         $scope.$ctrl.campaign = campaign;
         $scope.languages = campaign.settings.languages;
         $scope.changeTemplate(campaign.defaultLanguage, null);

         $('.modal-dialog').removeClass('modal-md').addClass('modal-lg');
         $scope.loaded.noEmail = true;
      });

      $scope.loadTemplates = function(template) {
         // load template list if super admin and not already loaded
         if (!session.isSuperAdmin() || $scope.templates.length > 0) {
            return;
         }

         $scope.loadingTemplates = true;
         emailApi.listTemplates('invite').then(function (res) {
            $scope.templates = res;
            $scope.loadingTemplates = false;
         });
      };

      $scope.changeTemplate = function(language, template) {
         if (language) {
            $scope.language = language;
         }

         if (!template) {
            template = typeDef.mandrill_template.replace('-env-', '-' + env + '-');
         }

         if ($scope.language != 'en') {
            template = template + '-' + $scope.language;
         }

         $scope.template = template;

         emailApi.templateInfo(template).then(function(res) {
            return editorCodeParser(res.code, true).then(function(doc) {
               $templateCache.put(template, doc.html);
               $scope.templateId = template;
            });
         });
      };

      $scope.cancel = function () {
         $uibModalInstance.dismiss('cancel');
      };

      $scope.send = function() {
         var params = {
            deployName: $scope.deployName
         };

         if (session.isSuperAdmin() && $scope.customTemplateEnabled) {
            params.template = $scope.template;
         }

         if (parseInt($scope.groupType) === 1) {
            params.ids = $scope.invitees.noEmail;
            $uibModalInstance.close(params);
         } else {
            params.ids = $scope.invitees.all;
            $uibModalInstance.close(params);
         }
      };
   }
]);
